// FollowedCities — « Mes villes » sur l'accueil : météo réelle + actualités web des villes suivies (diaspora).
import React, { useEffect, useState } from "react";
import axios from "axios";
import { MapPin, X, Newspaper } from "lucide-react";
import "./place.css";

const API = process.env.REACT_APP_BACKEND_URL;
const authHdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("civ_user_token") || ""}` } });

export default function FollowedCities({ onOpen }) {
  const [cities, setCities] = useState(null);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/v3/search/follow-places`, authHdr());
      if (!r.data?.ok || !r.data.places.length) { setCities([]); return; }
      const top = r.data.places.slice(0, 4);
      const enriched = await Promise.all(top.map(async (p) => {
        const [w, n] = await Promise.all([
          axios.get(`${API}/api/v3/search/place-weather`, { params: { slug: p.slug } }).then((x) => x.data?.ok ? x.data.weather : null).catch(() => null),
          axios.get(`${API}/api/v3/search/place-news`, { params: { slug: p.slug } }).then((x) => x.data?.ok ? x.data.news : []).catch(() => []),
        ]);
        return { ...p, weather: w, news: n || [] };
      }));
      setCities(enriched);
    } catch { setCities([]); }
  };
  useEffect(() => { if (localStorage.getItem("civ_user_token")) load(); else setCities([]); }, []);

  const unfollow = async (slug) => {
    try { await axios.delete(`${API}/api/v3/search/follow-places/${slug}`, authHdr()); } catch {}
    setCities((c) => (c || []).filter((x) => x.slug !== slug));
  };

  if (!cities || cities.length === 0) return null;
  return (
    <div className="fc-wrap" data-testid="followed-cities">
      <div className="fc-head"><MapPin size={14} color="#0E8A4F" /> Mes villes suivies</div>
      <div className="fc-row">
        {cities.map((c) => (
          <div key={c.slug} className="fc-card" data-testid={`followed-city-${c.slug}`}>
            <button className="fc-x" data-testid={`followed-unfollow-${c.slug}`} onClick={() => unfollow(c.slug)} aria-label={`Ne plus suivre ${c.name}`}><X size={11} /></button>
            <button className="fc-main" onClick={() => onOpen(c.name)}>
              <img src={c.image} alt="" />
              <div className="fc-bd">
                <b>{c.name}</b>
                {c.weather ? <span className="fc-w">{c.weather.emoji} {c.weather.temp}°C · {c.weather.label}</span> : <span className="fc-w">Voir la fiche</span>}
              </div>
            </button>
            {c.news[0] && (
              <a className="fc-news" href={c.news[0].url} target="_blank" rel="noreferrer" data-testid={`followed-news-${c.slug}`}>
                <Newspaper size={11} /> <span>{c.news[0].title}</span>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
